import { render, staticRenderFns } from "./ModalCreateQuestion.vue?vue&type=template&id=ce4daf34"
import script from "./ModalCreateQuestion.vue?vue&type=script&lang=js"
export * from "./ModalCreateQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports